import { useNavigationContainerRef } from 'expo-router'
import { useState, useEffect } from 'react'
import { create } from 'zustand'

const useIsNavigationReadyState = create<{
  isNavigationReady: boolean
  setNavigationReady: (isNavigationReady: boolean) => void
}>((set) => ({
  isNavigationReady: false,
  setNavigationReady: (isNavigationReady) => set({ isNavigationReady }),
}))

export const useIsNavigationReady = () => {
  const isNavigationReady = useIsNavigationReadyState(
    (s) => s.isNavigationReady
  )
  const setNavigationReady = useIsNavigationReadyState(
    (s) => s.setNavigationReady
  )
  const rootNavigation = useNavigationContainerRef()
  useEffect(() => {
    const unsubscribe = rootNavigation?.addListener('state', (e) => {
      setNavigationReady(true)
    })
    return () => {
      unsubscribe?.()
    }
  }, [])
  return isNavigationReady
}
